import {ChangeDetectionStrategy, Component} from '@angular/core';

/**
 * Пустой экран результатов поиска.
 */

@Component({
    selector: 'app-on-board',
    templateUrl: './on-board.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./on-board.component.scss']
})
export class OnBoardComponent {
}
